module.exports = __webpack_public_path__ + "static/img/80063D_2_3_R_20180429_n_LC.7c6f06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80063D_2_3_R_20180429_n_LC.png
// module id = p2FJ
// module chunks = 0